export default {"src":"/_next/static/media/BKR.623fad90.svg","height":18,"width":18};